import styled from 'styled-components/macro';
import { Typography } from '@la/ds-ui-components';
import { media } from 'lib/media-queries/mixins';

export const ConfirmationHead = styled(Typography)`
  margin-bottom: 4px;
`;

export const MessageBody = styled(Typography)`
  display: inline;

  ${media.TabletPortraitUp`
    display: inline-block;
  `}
`;
